import React from "react";

const SettingsModal = ({
    onClose,
    isBright,
    setIsBright,
    isAtMin,
    isAtMax,
    increaseFontScale,
    decreaseFontScale,
    handlePipetteClick,
    handleColorChange,
    colorInputRef,
    setCustomBackground,
    setFontScale
}) => {
    return (
        <div
            style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: isBright ? "#fff" : "#333",
                color: isBright ? "#000" : "#fff",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                zIndex: 1000,
            }}
        >
            <button
                onClick={onClose}
                style={{
                    float: "right",
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: isBright ? "#000" : "#fff",
                }}
            >
                ✖
            </button>

            <div style={{ display: "flex", flexWrap: "wrap", marginTop: "8px" }}>
                <img
                    tabIndex={0}
                    src={`/assets/icons/no-configuration-setting-icon.png`}
                    alt="Reset"
                    onClick={() => {
                        setCustomBackground(null);
                        setFontScale(1);
                        setIsBright(true);
                    }}
                    style={{ cursor: "pointer", margin: "8px" }}
                />

                <img
                    tabIndex={0}
                    src={`/assets/icons/picker-color-icon.png`}
                    alt="Color Picker"
                    onClick={handlePipetteClick}
                    style={{ cursor: "pointer", margin: "8px" }}
                />
                <input
                    type="color"
                    ref={colorInputRef}
                    style={{ display: "none" }}
                    onChange={handleColorChange}
                />

                <svg
                    tabIndex={0}
                    viewBox="0 0 512 423.65"
                    onClick={!isAtMin ? decreaseFontScale : undefined}
                    style={{
                        width: "24px",
                        height: "24px",
                        cursor: isAtMin ? "not-allowed" : "pointer",
                        fill: isAtMin ? "grey" : (isBright ? "black" : "white"),
                        margin: "8px"
                    }}
                >
                    <path d="M274.89 336.65H121.85l-29.09 87H0L157.6 0h80.94l158.6 423.65h-92.86l-29.39-87zm70.93-226.22V55.74H512v54.69H345.82zM145.39 265.74h105.96l-53.23-158.69-52.73 158.69z" />
                </svg>

                <svg
                    tabIndex={0}
                    viewBox="0 0 512 423.65"
                    onClick={!isAtMax ? increaseFontScale : undefined}
                    style={{
                        width: "24px",
                        height: "24px",
                        cursor: isAtMax ? "not-allowed" : "pointer",
                        fill: isAtMax ? "grey" : (isBright ? "black" : "white"),
                        margin: "8px"
                    }}
                >
                    <path d="M274.89 336.65H121.85l-29.09 87H0L157.6 0h80.94l158.6 423.65h-92.86l-29.39-87zm181.37-226.22v55.74h-54.69v-55.74h-55.75V55.74h55.75V0h54.69v55.74H512v54.69h-55.74zM145.39 265.74h105.96l-53.23-158.69-52.73 158.69z" />
                </svg>

                {isBright ? (
                    <img
                        tabIndex={0}
                        src={`/assets/icons/night-icon.png`}
                        alt="Switch to Dark Mode"
                        onClick={() => setIsBright(false)}
                        style={{ cursor: "pointer", margin: "8px" }}
                    />
                ) : (
                    <img
                        tabIndex={0}
                        src={`/assets/icons/sun-color-icon.png`}
                        alt="Switch to Bright Mode"
                        onClick={() => setIsBright(true)}
                        style={{ cursor: "pointer", margin: "8px" }}
                    />
                )}
            </div>
        </div>
    );
};

export default SettingsModal;
